import { render, staticRenderFns } from "./turnSiteForm1.vue?vue&type=template&id=7a1795c2&scoped=true&"
import script from "./turnSiteForm1.vue?vue&type=script&lang=js&"
export * from "./turnSiteForm1.vue?vue&type=script&lang=js&"
import style0 from "./turnSiteForm1.vue?vue&type=style&index=0&id=7a1795c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1795c2",
  null
  
)

export default component.exports